var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo, useCallback, useState } from 'react';
import { createPrefixCls } from '../_utils/string';
import PullLoad, { STATS } from './pull-load';
const prefixCls = createPrefixCls('scroll-view');
export const ScrollView = (_a) => {
    var { children, className, upperThreshold = 60, lowerThreshold = 40, onRefresh, onLoad, hasMore = false, header, footer, block = false } = _a, resetProps = __rest(_a, ["children", "className", "upperThreshold", "lowerThreshold", "onRefresh", "onLoad", "hasMore", "header", "footer", "block"]);
    const [action, setAction] = useState(STATS.INIT);
    const handRefreshing = useCallback(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (STATS.REFRESHING === action) {
                return false;
            }
            setAction(STATS.REFRESHING);
            onRefresh && (yield onRefresh());
            setAction(STATS.REFRESHED);
        }))();
    }, [action, onRefresh]);
    const handLoadMore = useCallback(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (STATS.LOADING === action) {
                return false;
            }
            if (!hasMore) {
                return;
            }
            setAction(STATS.LOADING);
            onLoad && (yield onLoad());
            setAction(STATS.RESET);
        }))();
    }, [action, hasMore, onLoad]);
    const handleAction = useCallback((nextAction) => {
        if (nextAction === action) {
            return false;
        }
        if (nextAction === STATS.REFRESHING) {
            handRefreshing();
        }
        else if (nextAction === STATS.LOADING) {
            handLoadMore();
        }
        else {
            setAction(nextAction);
        }
    }, [action, handLoadMore, handRefreshing]);
    const scrollViewCls = useMemo(() => {
        return classnames([prefixCls(), className]);
    }, [className]);
    return (React.createElement(PullLoad, Object.assign({ className: scrollViewCls, refreshEnable: !!onRefresh, loadEnable: !!onLoad, upperThreshold: upperThreshold, lowerThreshold: lowerThreshold, stat: action, onAction: handleAction, hasMore: hasMore, header: header, footer: footer, block: block }, resetProps),
        React.createElement("div", null, children)));
};
export default ScrollView;
